import { CompareState, CompareActions } from '../types';
import { TOGGLE_SEARCH_INPUT, SET_ADD_PRODUCT_ANIMATION } from '../actions';

import { trackAddProductAborted, trackAddProductStarted } from '../tracking';

const initialState: CompareState = {
  showSearchInput: false,
  shouldAnimate: false,
};

export default function reducer(
  state = initialState,
  action: CompareActions
): CompareState {
  if (!state) {
    return {
      ...initialState,
    };
  }

  switch (action.type) {
    case TOGGLE_SEARCH_INPUT: {
      // Tracking events
      if (state.showSearchInput) {
        trackAddProductAborted();
      } else {
        trackAddProductStarted();
      }

      return {
        ...state,
        showSearchInput: !state.showSearchInput,
      };
    }

    case SET_ADD_PRODUCT_ANIMATION: {
      return {
        ...state,
        shouldAnimate: action.state,
      };
    }

    default:
  }

  return state;
}
